// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "45e8b497be50a76b3fc2212822901b86" + ".js";
};